import { createContext, useContext } from "react";

export interface CRTNavigationContextValue {
  // Navigate to a path
  navigate: (path: string) => void;
  // Go back in history
  goBack: () => void;
  // Check if we can go back
  canGoBack: boolean;
  // Current path
  currentPath: string;
  // Transition state
  isTransitioning: boolean;
  // Transition direction
  transitionDirection: "forward" | "back";
}

export const CRTNavigationContext =
  createContext<CRTNavigationContextValue | null>(null);

export function useCRTNavigation() {
  const context = useContext(CRTNavigationContext);
  if (!context) {
    throw new Error(
      "useCRTNavigation must be used within a CRTRouter component",
    );
  }
  return context;
}
